import React from 'react';

const brandTexts = {
  acom: {
    title: <>poxa, produto sem estoque :(</>,
    description: (
      <>
        <span>Mas não fica triste, não! Você ainda</span> pode ver muuuitos produtos parecidos, <span>vamos lá?</span>
      </>
    ),
    buttonText: <>ver produtos parecidos</>,
  },
  aemp: {
    title: <>poxa, produto sem estoque :(</>,
    description: (
      <>
        <span>Mas não fica triste, não! Você ainda</span> pode ver muuuitos produtos parecidos, <span>vamos lá?</span>
      </>
    ),
    buttonText: <>ver produtos parecidos</>,
  },
  suba: {
    title: <>Ops, produto sem estoque</>,
    description: (
      <>
        Mas nada de ir embora, SubLover. Você ainda tem muitos produtos parecidos <span>para explorar, vamos lá?</span>
      </>
    ),
    buttonText: <>Ver produtos parecidos</>,
  },
  shop: {
    title: <>Produto sem estoque</>,
    description: <>Não se preocupe: você ainda pode ver produtos similares e fazer a melhor compra.</>,
    buttonText: <>VER PRODUTOS SIMILARES</>,
  },
};

export const getTextByBrand = brand => brandTexts[brand];
